module.exports = __webpack_public_path__ + "catalog/items/firesafety/Call Point/Callpoint.svg";